var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.83 8.83 0 0 1-8.829 8.828z",
    fill: "#82afff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.277h-25.305L0 335.449v17.655L508.367 90.156c-1.474-1.103-3.212-1.879-5.195-1.879zM8.828 423.725h25.305L512 176.553v-17.655L3.633 421.846c1.474 1.103 3.212 1.879 5.195 1.879z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.367 90.156L0 353.104v61.793c0 2.893 1.483 5.339 3.633 6.948L512 158.898V97.104c0-2.893-1.483-5.338-3.633-6.948z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.619 122.979l12.718 38.135 40.199.311c2.248.018 3.18 2.886 1.372 4.222l-32.339 23.881 12.126 38.328c.678 2.143-1.762 3.916-3.591 2.609l-32.705-23.377-32.705 23.377c-1.828 1.308-4.269-.466-3.591-2.609l12.126-38.328-32.339-23.881c-1.809-1.335-.876-4.204 1.372-4.222l40.199-.311 12.718-38.135c.713-2.132 3.728-2.132 4.44 0z",
    fill: "#ffe15a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/cd.2d99f31667be4ad1c8b06a79b5f8b450.svg";
export { ForwardRef as ReactComponent };